import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { uploader } from "@/utils/alioss";
import { watch, ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'upload-file-item',
  props: {
    // v-model绑定的值
    file: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['delete', 'success', 'fail'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const uploadStatus = ref(0);
    const startUpload = async () => {
      // 1、图片，2、视频，3、文件
      props.file.mediaType = 3;
      // 上传至oss
      try {
        uploadStatus.value = 1;
        const res = await uploader(props.file.file);
        uploadStatus.value = 2;
        props.file.url = res.url;
        emits('success');
        console.log('上传成功', props.file.url);
      } catch (e) {
        uploadStatus.value = 3;
        emits('fail');
        console.error('上传失败', e);
      }
    };
    // 删除
    const deleteClick = () => {
      if (uploadStatus.value == 1) return;
      emits('delete');
    };
    watch(() => props.file, () => {
      startUpload();
    }, {
      immediate: true
    });
    watch(uploadStatus, v => {
      props.file.mediaStatus = v.value;
    });
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["upload-file-item", {
          'upload-fail': uploadStatus.value == 3,
          'upload-ing': uploadStatus.value == 1
        }]),
        onClick: deleteClick
      }, [_createElementVNode("span", null, [_createTextVNode(_toDisplayString(__props.file.name), 1), _createElementVNode("span", {
        onClick: startUpload,
        class: "error-title"
      }, _toDisplayString(uploadStatus.value == 3 ? '[上传失败，点我重试]' : ''), 1)]), _createVNode(_component_van_icon, {
        name: "cross"
      })], 2);
    };
  }
});